export default __webpack_public_path__ + "static/media/ic_chevron_down.a90ab977.svg";